import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex flex-column align-items-center justify-content-center pt-3 pb-3" }
const _hoisted_2 = { class: "align-items-center flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "KRABICA", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_5 = { class: "field flex justify-content-center" }
const _hoisted_6 = { class: "field flex justify-content-center" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "box-code" }, "Kód", -1)
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "box-location" }, "Umiestnenie", -1)
const _hoisted_11 = {
  class: "field",
  style: {"position":"relative"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "box-order" }, "Objednávka", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "flex justify-content-center align-items-center",
  style: {"width":"1.8rem"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "p-icon p-button-icon"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_15 = {
  key: 0,
  class: "card",
  style: {"z-index":"10","position":"absolute","top":"56px","left":"2px","min-width":"20rem","transform-origin":"center top","margin-top":"2px"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_17 = { class: "field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "box-customer" }, "Zákazník", -1)
const _hoisted_19 = { class: "field" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "proform" }, "Cortizo proforma", -1)
const _hoisted_21 = {
  key: 0,
  class: ""
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "field flex justify-content-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "mt-0 mb-2 border-solid border-1 surface-border" }, null, -1)
const _hoisted_26 = { class: "mb-1 flex flex-wrap justify-content-center gap-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueTag = _resolveComponent("PrimevueTag")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PrimevueCard, { class: "sm:w-12 md:w-8 lg:w-8 xl:w-6 mb-2" }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_PrimevueTag, {
              class: "p-1 font-medium text-base justify-content-center",
              value: this.box.opened ? 'otvorená' : 'zatvorená',
              severity: this.box.opened ? 'success' : 'danger',
              rounded: ""
            }, null, 8, ["value", "severity"])
          ])
        ]),
        subtitle: _withCtx(() => [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/mod-stock/scan-item",
              class: "w-8"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PrimevueButton, {
                  label: "Skenovať QR kód",
                  severity: "success",
                  icon: "pi pi-camera",
                  text: "",
                  raised: "",
                  class: "uppercase w-full"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_PrimevueButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.printLabel())),
              label: "Vytlač štítok",
              disabled: !(this.box.id > 0),
              icon: "pi pi-print",
              severity: "success",
              text: "",
              raised: "",
              class: "w-8 uppercase"
            }, null, 8, ["disabled"])
          ])
        ]),
        content: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitHandler && $options.submitHandler(...args)), ["prevent"])),
            name: "boxForm",
            class: ""
          }, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_InputText, {
                class: "w-full",
                modelValue: this.box.code,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.box.code) = $event)),
                disabled: "",
                type: "text",
                name: "box-code",
                id: "box-code"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_InputText, {
                class: "w-full",
                modelValue: this.box.location,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.box.location) = $event)),
                type: "text",
                name: "box-location",
                id: "box-location"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_PrimevueButton, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (this.visibleSelect = !this.visibleSelect)),
                label: "test",
                style: {"height":"1.9rem"},
                class: _normalizeClass(["flex justify-content-between w-full", `${$setup.v$.box.order.$error ? 'bg-red-200' : ''}`]),
                outlined: "",
                id: "box-order"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    (this.box.order.id > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                          _createElementVNode("span", null, _toDisplayString(this.box.order.orderCode), 1),
                          _createTextVNode(" * "),
                          _createElementVNode("span", null, _toDisplayString(this.box.customer.lastName), 1),
                          _createTextVNode(" * "),
                          _createElementVNode("span", null, _toDisplayString(this.box.customer.city), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["class"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.box.order.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "text-sm font-italic text-red-400"
                }, _toDisplayString(error.$message), 1))
              }), 128)),
              (this.visibleSelect)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_IconField, { iconPosition: "left" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputIcon, null, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_InputText, {
                          modelValue: $data.orderFilters['global'].value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.orderFilters['global'].value) = $event)),
                          placeholder: "Vyhľadať",
                          onInput: $options.onOrderFilter
                        }, null, 8, ["modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DataTable, {
                      lazy: "",
                      paginator: "",
                      rows: this.selectParams.rows,
                      onPage: $options.onOrderPage,
                      first: this.selectParams.first,
                      loading: $data.selectLoading,
                      totalRecords: this.selectParams.totalRecords,
                      dataKey: "id",
                      value: this.orderOptions,
                      scrollHeight: `${200}px`,
                      virtualScrollerOptions: { itemSize: 40 },
                      stripedRows: "",
                      "row-hover": "",
                      scrollable: "",
                      selection: this.selectedOrder,
                      "onUpdate:selection": _cache[5] || (_cache[5] = ($event: any) => ((this.selectedOrder) = $event)),
                      selectionMode: "single",
                      metaKeySelection: false,
                      onRowSelect: _cache[6] || (_cache[6] = ($event: any) => ($options.selectOrder(this.selectedOrder))),
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          header: "ID",
                          field: "orderCode",
                          style: {"width":"5%"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Meno",
                          field: "customer.lastName",
                          style: {"width":"50%"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Obec",
                          field: "customer.city",
                          style: {"width":"45%"}
                        })
                      ]),
                      _: 1
                    }, 8, ["rows", "onPage", "first", "loading", "totalRecords", "value", "selection"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_InputText, {
                disabled: "",
                class: "w-full",
                modelValue: this.box.customer.lastName,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.box.customer.lastName) = $event)),
                type: "text",
                name: "box-customer",
                id: "box-customer"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_PrimevueSelect, {
                id: "proform",
                editable: this.box.cortizoProform.id == 0,
                disabled: !(this.box.order.id > 0),
                modelValue: this.selectedProform,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.selectedProform) = $event)),
                options: this.proformOptions,
                optionLabel: "code",
                placeholder: "Vyber alebo zadaj číslo proformy",
                class: _normalizeClass(["w-full", `${$setup.v$.selectedProform.$error ? 'bg-red-200' : ''}`]),
                invalid: $setup.v$.selectedProform.$error
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.value.code), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_22, " Vyber alebo zadaj číslo proformy "))
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", null, _toDisplayString(slotProps.option.code), 1)
                  ])
                ]),
                _: 1
              }, 8, ["editable", "disabled", "modelValue", "options", "class", "invalid"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedProform.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "text-sm font-italic text-red-400"
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_24, [
              (!this.box.opened)
                ? (_openBlock(), _createBlock(_component_PrimevueButton, {
                    key: 0,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.openBox())),
                    label: "Otvor krabicu",
                    severity: "success",
                    text: "",
                    raised: "",
                    class: "w-8 uppercase"
                  }))
                : _createCommentVNode("", true),
              (this.box.opened)
                ? (_openBlock(), _createBlock(_component_PrimevueButton, {
                    key: 1,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.closeBox())),
                    label: "Zatvor krabicu",
                    severity: "secondary",
                    text: "",
                    raised: "",
                    class: "w-8 uppercase"
                  }))
                : _createCommentVNode("", true)
            ]),
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_PrimevueButton, {
                type: "submit",
                label: "Uložiť",
                text: "",
                raised: "",
                class: "uppercase"
              }),
              _createVNode(_component_router_link, { to: "/mod-stock/boxies" }, {
                default: _withCtx(() => [
                  _createVNode(_component_PrimevueButton, {
                    label: "Zrušiť",
                    severity: "danger",
                    text: "",
                    raised: "",
                    class: "uppercase"
                  })
                ]),
                _: 1
              })
            ])
          ], 32)
        ]),
        _: 1
      }),
      _createVNode(_component_PrimevueCard, { class: "sm:w-12 md:w-8 lg:w-8 xl:w-6" }, {
        title: _withCtx(() => [
          _createTextVNode("Pohyby s krabicou")
        ]),
        subtitle: _withCtx(() => [
          _hoisted_27
        ]),
        content: _withCtx(() => [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.stockMovements, (history) => {
              return (_openBlock(), _createElementBlock("li", {
                key: history.id
              }, [
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString($options.Utils.formatToSlovak(history.createdAt)) + " ", 1),
                _createVNode(_component_PrimevueTag, {
                  class: "text-base",
                  value: history.action,
                  style: _normalizeStyle({ backgroundColor: history.color })
                }, null, 8, ["value", "style"]),
                _createTextVNode(" - " + _toDisplayString(history.user.firstName) + " " + _toDisplayString(history.user.lastName), 1)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}